import Choices from 'choices.js';
// import Lenis from '@studio-freight/lenis';
import GLightbox from 'glightbox';
import Pikaday from 'pikaday';

import AgeGate from '../_modules/age-gate';
import Header from '../_modules/header';
import Hero from '../_modules/hero';
import HeroSlider from '../_modules/hero-slider';
import LoadMorePosts from '../_modules/load-more-posts';
import Menu from '../_modules/menu';
import Modal from '../_modules/modal';
import PopUp from '../_modules/pop-up';
import SliderLogo from '../_modules/slider-logo';
import SliderProduct from '../_modules/slider-product';
import SliderPosts from '../_modules/slider-posts';
import Video from '../_modules/video';

import '../../styles/frontend/frontend.scss';

window.addEventListener('load', () => {
    // Prevent FOUC
    document.getElementsByTagName('html')[0].classList.remove('is-dom-loading');

    // Lenis
    // const lenis = new Lenis({
    //     duration: 1.2,
    //     easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
    //     direction: 'vertical',
    //     gestureDirection: 'vertical',
    //     smooth: true,
    //     mouseMultiplier: 1,
    //     smoothTouch: false,
    //     touchMultiplier: 2,
    //     infinite: false,
    // });

    // function raf(time) {
    //     lenis.raf(time);
    //     requestAnimationFrame(raf);
    // }

    // requestAnimationFrame(raf);

    // Select
    const selects = document.querySelectorAll('.c-form select');

    setTimeout(() => {
        selects.forEach((select) => {
            new Choices(select, {
                itemSelectText: '',
                shouldSort: false,
                callbackOnCreateTemplates: function (template) {
                    return {
                        choice: ({ classNames }, data) => {
                            return template(`
                                <div data-lenis-prevent class="${
                                    classNames.item
                                } ${classNames.itemChoice} ${
                                data.disabled
                                    ? classNames.itemDisabled
                                    : classNames.itemSelectable
                            }" data-select-text="${
                                this.config.itemSelectText
                            }" data-choice ${
                                data.disabled
                                    ? 'data-choice-disabled aria-disabled="true"'
                                    : 'data-choice-selectable'
                            } data-id="${data.id}" data-value="${data.value}" ${
                                data.groupId > 0
                                    ? 'role="treeitem"'
                                    : 'role="option"'
                            }>
                            ${data.label}
                                    </div>
                            `);
                        },
                    };
                },
            });
        });
    }, '100');

    // Initiate Pikaday
    new Pikaday({
        field: document.getElementById('cf7-302-date'),
        setDefaultDate: true,
    });

    // Initiate GLightbox
    GLightbox({
        selector: '.glightbox-landscape',
        autoplayVideos: true,
        loop: true,
        touchNavigation: true,
    });

    const lightbox = GLightbox({
        selector: '.glightbox-portrait',
        autoplayVideos: true,
        loop: true,
        touchNavigation: true,
        plyr: {
            config: {
                ratio: '9:16',
            },
        },
    });

    window.addEventListener('load-more-posts-complete', () => {
        lightbox.destroy();
    });

    // Initiate modules
    new AgeGate();
    new Menu();
    new PopUp();
    new Header();
    new Hero();
    new HeroSlider();
    new LoadMorePosts();
    new Modal();
    new SliderLogo();
    new SliderPosts();
    new SliderProduct();
    new Video();
});
